import { appstr } from "../utils/appstr";
import { QSubChart } from "./QSubChart";
import { QXMLObject } from "./QXMLObject";

export class QSubChartBreak extends QXMLObject {
  constructor() {
    super();
    this.fType = null;
    this.fParent = null;
    this.fChildren = null;
  }

  InitBreak(type, parent, children, timestamp, user) {
    this.SetXMLElementName("break");
    this.fType = type;
    this.fParent = parent;
    this.fChildren = children;
    this.fTimestamp = timestamp;
    this.fUser = user;
  }

  GetBreakParent() {
    return this.fParent;
  }

  GetBreakChildren() {
    return this.fChildren;
  }

  GetBreakType() {
    return this.fType;
  }

  GetBreakTypeStr() {
    let type = this.GetBreakType();
    let str = "";
    switch (type) {
      case "remove":
        str = appstr("Removed subchart break");
        break;
      case "insert":
        str = appstr("Inserted subchart break");
        break;
      case "rename":
        str = appstr("Renamed Subchart");
        break;
    }
    return str;
  }

  LoadFromJSON(json) {
    this.fType = json["type"];
    this.fParent = json["parent"];
    if (this.fType == "rename" && json["name"]) this.fName = json["name"];
    this.fChildren = json["children"];
    this.fUser = json["user"];
    this.fTimestamp = json["timestamp"];
  }

  OutputToJSON(stream) {
    var breakObj = {};
    breakObj["type"] = this.fType;
    breakObj["parent"] = this.fParent;
    if (this.fType == "rename" && this.fName) breakObj["name"] = this.fName;

    if (this.fChildren) breakObj["children"] = this.fChildren;

    breakObj["user"] = this.fUser;
    breakObj["timestamp"] = this.fTimestamp;
    return breakObj;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("type", this.fType, stream);
    this.OutputSimpleElement("parent", this.fParent, stream);
    if (this.fType == "rename" && this.fName) this.OutputSimpleElement("name", this.fName, stream);
  }

  OutputChildElements(stream) {
    this.OutputElementList("children", this.fChildren, stream);
  }

  LoadSubElements(objTree) {
    this.SetXMLElementName("break");
    var type = objTree.GetValueForChild("type", false);
    this.fType = type;
    var parent = objTree.GetValueForChild("parent", false);
    this.fParent = parent;
    if (this.fType == "rename") {
      var name = objTree.GetValueForChild("name", false);
      if (name) this.fName = name;
    }
  }

  LoadChildElements(objTree) {
    var childList = objTree.GetValueForChild("children", false);
    //TODO: Unsafe if personIDS have commas in them.
    this.fChildren = childList.split(",");
  }
}
